

















import Vue from "vue";
import { mapState, mapActions } from "vuex";
import CustomerDetails from "../Project/CustomerDetails.vue";
import DesignerAssignment from "../Project/DesignerAssignment.vue";

export default Vue.extend({
  components: {
    CustomerDetails,
    DesignerAssignment,
  },
  data(): { [key: string]: any } {
    return {
      saveBtn: {
        isDisabled: false,
        text: "Assign",
      },
    };
  },

  computed: {
    ...mapState("appModule", {
      currentProject: "currentProject",
      leadType: "leadType",
    }),
    customerDetails(): { [key: string]: any } | null {
      if ((this as any).currentProject) {
        return {
          id: (this as any).currentProject.id,
          pincode: (this as any).currentProject.pincode,
          name: (this as any).currentProject.customer.name,
          email: (this as any).currentProject.customer.email,
          phone: (this as any).currentProject.customer.phone,
          propertyName: "-",
          leadType: (this as any).leadType,
          creationDate: (this as any).formatDate(
            (this as any).currentProject.created_at
          ),
          projectStage: (this as any).currentProject.stage.display_name
            ? (this as any).currentProject.stage.display_name
            : "-",
          projectStatus: (this as any).currentProject.status,
        };
      } else {
        return null;
      }
    },
  },
  methods: {
    ...mapActions("appModule", ["getProjectDetails"]),
    formatDate(date: string) {
      if (date) {
        const formatDate = new Date(date).toJSON();
        return formatDate.substring(0, formatDate.length - 1);
      }
      return "";
    },
  },
  async mounted() {
    if ((this as any).$router.currentRoute.params.project_id) {
      await (this as any).getProjectDetails(
        (this as any).$router.currentRoute.params.project_id
      );
    }
  },
});
